import React, {  } from "react";
import { Typography, Grid } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import Backlink from "../../home-page/search/view/_back-link";
import { Link } from "react-router-dom";
const useStyles = makeStyles((theme) =>
  createStyles({
    heading: {
      color: theme.palette.ePrimary?.base,
      fontWeight: "bold",
      marginLeft: "0.25rem",
      marginBottom: "1%",
    },
    description: {
      maxWidth: "75rem",
      marginLeft: "0.25rem",
      marginBottom: "0.5rem",
    },
    contentGrid: {
      flexFlow: "column",
    },
  })
);

const EPrepaidPaymentsHeader = () => {
  const classes = useStyles();
  const { t: labels, ready: labelreadyok } = useTranslation("label-E_ONE_TIME_PAYMENTS");

  return (
    <Grid container>
      <Grid item container className={classes.contentGrid}>
        <Grid item>
          <Backlink />
        </Grid>
        <Grid item>
          <Typography variant="h5" className={classes.heading}>
          {labelreadyok?labels("E_ONE_TIME_PAYMENTS"):""}
          </Typography>
        </Grid>
        <Grid item className={classes.description}>
        <Typography variant="body2">{labelreadyok?labels("E_DESC_TEXT_ONE"):""} {labelreadyok?labels("E_DESC_TEXT_LINK"):""} {labelreadyok?labels("E_DESC_TEXT_TWO"):""}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EPrepaidPaymentsHeader;
